// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ImengImageGenNode 样式 - 即梦4.0 生图节点 */

/* 节点容器 */
.ImengImageGenNode-container {
  position: relative;
  background: white;
  border: 2px solid #6366f1; /* 紫色主题 */
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  min-width: 340px;
}

.ImengImageGenNode-container:hover {
  box-shadow: 0 8px 24px rgba(99, 102, 241, 0.2);
  border-color: #4f46e5;
}

/* 标题栏 */
.ImengImageGenNode-title {
  padding: 12px 16px;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: white;
  font-weight: 600;
  font-size: 14px;
  border-radius: 10px 10px 0 0;
  text-align: center;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* 模式徽章 */
.ImengImageGenNode-mode-badge {
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 8px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ImengImageGenNode-mode-t2i {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.ImengImageGenNode-mode-i2i {
  background: rgba(16, 185, 129, 0.9);
  color: white;
}

/* Handle 样式 */
.ImengImageGenNode-handle {
  width: 14px;
  height: 14px;
  border: 2px solid #6366f1;
  background: white;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.ImengImageGenNode-handle:hover {
  width: 18px;
  height: 18px;
  border-width: 3px;
}

.ImengImageGenNode-handle-prompt {
  border-color: #667eea;
  background: #667eea;
}

.ImengImageGenNode-handle-image {
  border-color: #48bb78;
  background: #48bb78;
}

.ImengImageGenNode-handle-output {
  border-color: #6366f1;
  background: #6366f1;
}

/* Handle 标签 */
.ImengImageGenNode-handle-label {
  position: absolute;
  left: -70px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.025em;
  z-index: 100;
}

/* 可点击的 Handle 标签 */
.ImengImageGenNode-handle-label-clickable {
  pointer-events: auto;  /* 改为可交互 */
  cursor: pointer;       /* 显示手型光标 */
  user-select: none;     /* 禁止文本选择 */
}

/* 可点击标签的悬停效果 */
.ImengImageGenNode-handle-label-clickable:hover {
  transform: translateY(-50%) translateX(-4px) scale(1.05);
  box-shadow: 0 8px 24px rgba(99, 102, 241, 0.45);
  background: linear-gradient(135deg, #818cf8 0%, #6366f1 100%);
}

/* 可点击标签的按下效果 */
.ImengImageGenNode-handle-label-clickable:active {
  transform: translateY(-50%) translateX(-2px) scale(0.98);
}

/* 添加点击提示图标 */
.ImengImageGenNode-handle-label-clickable::after {
  content: ' +';
  font-weight: 700;
  margin-left: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.ImengImageGenNode-handle-label-clickable:hover::after {
  opacity: 1;
}

.ImengImageGenNode-handle:hover .ImengImageGenNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.35);
}

.ImengImageGenNode-handle:hover .ImengImageGenNode-handle-label::before {
  content: '';
  position: absolute;
  right: -4px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid #6366f1;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  filter: drop-shadow(0 1px 2px rgba(99, 102, 241, 0.2));
}

.ImengImageGenNode-handle-prompt .ImengImageGenNode-handle-label {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}

.ImengImageGenNode-handle-prompt:hover .ImengImageGenNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.ImengImageGenNode-handle-prompt:hover .ImengImageGenNode-handle-label::before {
  border-left-color: #667eea;
  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));
}

.ImengImageGenNode-handle-image .ImengImageGenNode-handle-label {
  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);
}

.ImengImageGenNode-handle-image:hover .ImengImageGenNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

.ImengImageGenNode-handle-image:hover .ImengImageGenNode-handle-label::before {
  border-left-color: #48bb78;
  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));
}

/* 节点被选中时，一直显示标签 */
.react-flow__node.selected .ImengImageGenNode-handle .ImengImageGenNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.35);
}

.react-flow__node.selected .ImengImageGenNode-handle-prompt .ImengImageGenNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.react-flow__node.selected .ImengImageGenNode-handle-image .ImengImageGenNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

/* 标签出现动画 */
@keyframes ImengImageGenNode-labelFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) translateX(-2px);
  }
}

.ImengImageGenNode-handle:hover .ImengImageGenNode-handle-label,
.react-flow__node.selected .ImengImageGenNode-handle .ImengImageGenNode-handle-label {
  animation: ImengImageGenNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 内容包装器 */
.ImengImageGenNode-wrapper {
  padding: 16px;
  width: 340px;
}

.ImengImageGenNode-field {
  margin-bottom: 12px;
}

.ImengImageGenNode-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
}

.ImengImageGenNode-button-group {
  display: flex;
  gap: 8px;
}

.ImengImageGenNode-button {
  flex: 1;
  padding: 8px;
  background: white;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.ImengImageGenNode-button:hover {
  background: #f8fafc;
  border-color: #6366f1;
}

.ImengImageGenNode-button-active {
  background: #6366f1;
  color: white;
  border-color: #6366f1;
}

.ImengImageGenNode-select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  background: white;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.ImengImageGenNode-select:focus {
  outline: none;
  border-color: #6366f1;
}

.ImengImageGenNode-select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

/* 连接提示 */
.ImengImageGenNode-hint {
  margin-bottom: 12px;
  padding: 12px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid #bae6fd;
  border-radius: 8px;
  font-size: 12px;
  color: #0c4a6e;
  line-height: 1.5;
  border-left: 4px solid #6366f1;
}

.ImengImageGenNode-hint strong {
  color: #0369a1;
}

/* 生成按钮 */
.ImengImageGenNode-generate {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;
  position: relative;
  overflow: hidden;
}

.ImengImageGenNode-generate::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.ImengImageGenNode-generate:hover::before {
  left: 100%;
}

.ImengImageGenNode-generate:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
}

.ImengImageGenNode-generate:active {
  transform: translateY(0);
}

.ImengImageGenNode-generate-disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

.ImengImageGenNode-generate-disabled::before {
  display: none;
}

/* 错误提示 */
.ImengImageGenNode-error {
  padding: 8px 12px;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fecaca;
  border-radius: 6px;
  font-size: 12px;
  color: #dc2626;
  border-left: 4px solid #dc2626;
}

/* 参考图片网格展示 */
.ImengImageGenNode-image-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-top: 8px;
}

.ImengImageGenNode-image-thumb {
  position: relative;
  aspect-ratio: 1;
  border-radius: 6px;
  overflow: hidden;
  border: 2px solid #e5e7eb;
  cursor: move;
  transition: all 0.2s;
  background: #f9fafb;
}

.ImengImageGenNode-image-thumb:hover {
  border-color: #6366f1;
  transform: scale(1.05);
  z-index: 10;
  box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);
}

.ImengImageGenNode-image-dragging {
  opacity: 0.5;
  transform: scale(0.95);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.ImengImageGenNode-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.ImengImageGenNode-thumb-index {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(99, 102, 241, 0.9);
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
}

/* 复制按钮样式 */
.ImengImageGenNode-duplicate-button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s ease;
  opacity: 0;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ImengImageGenNode-container:hover .ImengImageGenNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

.ImengImageGenNode-duplicate-button:hover {
  background: #f0f0f0;
  border-color: #6366f1;
  color: #6366f1;
  transform: scale(1.05);
}

.ImengImageGenNode-duplicate-button:active {
  transform: scale(0.95);
}

.react-flow__node.selected .ImengImageGenNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .ImengImageGenNode-container {
    min-width: 280px;
  }

  .ImengImageGenNode-wrapper {
    width: 280px;
  }

  .ImengImageGenNode-image-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* 动画效果 */
@keyframes imengPulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.ImengImageGenNode-generate:not(.ImengImageGenNode-generate-disabled) {
  animation: imengPulse 2s infinite;
}
`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/ImengImageGenNode.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC,SAAS;AACT;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB,EAAE,SAAS;EACpC,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA,QAAQ;AACR;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,SAAS;AACT;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;EACzC,uBAAuB;EACvB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,oBAAoB,GAAG,UAAU;EACjC,eAAe,QAAQ,WAAW;EAClC,iBAAiB,MAAM,WAAW;AACpC;;AAEA,eAAe;AACf;EACE,wDAAwD;EACxD,+CAA+C;EAC/C,6DAA6D;AAC/D;;AAEA,eAAe;AACf;EACE,wDAAwD;AAC1D;;AAEA,aAAa;AACb;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,WAAW;AACX;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;;EAEE,0EAA0E;AAC5E;;AAEA,UAAU;AACV;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mCAAmC;EACnC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA,UAAU;AACV;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,SAAS;AACT;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["/* ImengImageGenNode 样式 - 即梦4.0 生图节点 */\n\n/* 节点容器 */\n.ImengImageGenNode-container {\n  position: relative;\n  background: white;\n  border: 2px solid #6366f1; /* 紫色主题 */\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n  min-width: 340px;\n}\n\n.ImengImageGenNode-container:hover {\n  box-shadow: 0 8px 24px rgba(99, 102, 241, 0.2);\n  border-color: #4f46e5;\n}\n\n/* 标题栏 */\n.ImengImageGenNode-title {\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  border-radius: 10px 10px 0 0;\n  text-align: center;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n/* 模式徽章 */\n.ImengImageGenNode-mode-badge {\n  font-size: 10px;\n  padding: 2px 6px;\n  border-radius: 8px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.ImengImageGenNode-mode-t2i {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n}\n\n.ImengImageGenNode-mode-i2i {\n  background: rgba(16, 185, 129, 0.9);\n  color: white;\n}\n\n/* Handle 样式 */\n.ImengImageGenNode-handle {\n  width: 14px;\n  height: 14px;\n  border: 2px solid #6366f1;\n  background: white;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.ImengImageGenNode-handle:hover {\n  width: 18px;\n  height: 18px;\n  border-width: 3px;\n}\n\n.ImengImageGenNode-handle-prompt {\n  border-color: #667eea;\n  background: #667eea;\n}\n\n.ImengImageGenNode-handle-image {\n  border-color: #48bb78;\n  background: #48bb78;\n}\n\n.ImengImageGenNode-handle-output {\n  border-color: #6366f1;\n  background: #6366f1;\n}\n\n/* Handle 标签 */\n.ImengImageGenNode-handle-label {\n  position: absolute;\n  left: -70px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  letter-spacing: 0.025em;\n  z-index: 100;\n}\n\n/* 可点击的 Handle 标签 */\n.ImengImageGenNode-handle-label-clickable {\n  pointer-events: auto;  /* 改为可交互 */\n  cursor: pointer;       /* 显示手型光标 */\n  user-select: none;     /* 禁止文本选择 */\n}\n\n/* 可点击标签的悬停效果 */\n.ImengImageGenNode-handle-label-clickable:hover {\n  transform: translateY(-50%) translateX(-4px) scale(1.05);\n  box-shadow: 0 8px 24px rgba(99, 102, 241, 0.45);\n  background: linear-gradient(135deg, #818cf8 0%, #6366f1 100%);\n}\n\n/* 可点击标签的按下效果 */\n.ImengImageGenNode-handle-label-clickable:active {\n  transform: translateY(-50%) translateX(-2px) scale(0.98);\n}\n\n/* 添加点击提示图标 */\n.ImengImageGenNode-handle-label-clickable::after {\n  content: ' +';\n  font-weight: 700;\n  margin-left: 4px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.ImengImageGenNode-handle-label-clickable:hover::after {\n  opacity: 1;\n}\n\n.ImengImageGenNode-handle:hover .ImengImageGenNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.35);\n}\n\n.ImengImageGenNode-handle:hover .ImengImageGenNode-handle-label::before {\n  content: '';\n  position: absolute;\n  right: -4px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 4px solid #6366f1;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  filter: drop-shadow(0 1px 2px rgba(99, 102, 241, 0.2));\n}\n\n.ImengImageGenNode-handle-prompt .ImengImageGenNode-handle-label {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);\n}\n\n.ImengImageGenNode-handle-prompt:hover .ImengImageGenNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.ImengImageGenNode-handle-prompt:hover .ImengImageGenNode-handle-label::before {\n  border-left-color: #667eea;\n  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));\n}\n\n.ImengImageGenNode-handle-image .ImengImageGenNode-handle-label {\n  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);\n  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);\n}\n\n.ImengImageGenNode-handle-image:hover .ImengImageGenNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n.ImengImageGenNode-handle-image:hover .ImengImageGenNode-handle-label::before {\n  border-left-color: #48bb78;\n  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));\n}\n\n/* 节点被选中时，一直显示标签 */\n.react-flow__node.selected .ImengImageGenNode-handle .ImengImageGenNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.35);\n}\n\n.react-flow__node.selected .ImengImageGenNode-handle-prompt .ImengImageGenNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.react-flow__node.selected .ImengImageGenNode-handle-image .ImengImageGenNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n/* 标签出现动画 */\n@keyframes ImengImageGenNode-labelFadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-50%) translateX(-10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(-50%) translateX(-2px);\n  }\n}\n\n.ImengImageGenNode-handle:hover .ImengImageGenNode-handle-label,\n.react-flow__node.selected .ImengImageGenNode-handle .ImengImageGenNode-handle-label {\n  animation: ImengImageGenNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* 内容包装器 */\n.ImengImageGenNode-wrapper {\n  padding: 16px;\n  width: 340px;\n}\n\n.ImengImageGenNode-field {\n  margin-bottom: 12px;\n}\n\n.ImengImageGenNode-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 6px;\n}\n\n.ImengImageGenNode-button-group {\n  display: flex;\n  gap: 8px;\n}\n\n.ImengImageGenNode-button {\n  flex: 1;\n  padding: 8px;\n  background: white;\n  color: #333;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.ImengImageGenNode-button:hover {\n  background: #f8fafc;\n  border-color: #6366f1;\n}\n\n.ImengImageGenNode-button-active {\n  background: #6366f1;\n  color: white;\n  border-color: #6366f1;\n}\n\n.ImengImageGenNode-select {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  background: white;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.ImengImageGenNode-select:focus {\n  outline: none;\n  border-color: #6366f1;\n}\n\n.ImengImageGenNode-select:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n/* 连接提示 */\n.ImengImageGenNode-hint {\n  margin-bottom: 12px;\n  padding: 12px;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  border: 1px solid #bae6fd;\n  border-radius: 8px;\n  font-size: 12px;\n  color: #0c4a6e;\n  line-height: 1.5;\n  border-left: 4px solid #6366f1;\n}\n\n.ImengImageGenNode-hint strong {\n  color: #0369a1;\n}\n\n/* 生成按钮 */\n.ImengImageGenNode-generate {\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  position: relative;\n  overflow: hidden;\n}\n\n.ImengImageGenNode-generate::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s;\n}\n\n.ImengImageGenNode-generate:hover::before {\n  left: 100%;\n}\n\n.ImengImageGenNode-generate:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);\n}\n\n.ImengImageGenNode-generate:active {\n  transform: translateY(0);\n}\n\n.ImengImageGenNode-generate-disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.ImengImageGenNode-generate-disabled::before {\n  display: none;\n}\n\n/* 错误提示 */\n.ImengImageGenNode-error {\n  padding: 8px 12px;\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #dc2626;\n  border-left: 4px solid #dc2626;\n}\n\n/* 参考图片网格展示 */\n.ImengImageGenNode-image-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.ImengImageGenNode-image-thumb {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 2px solid #e5e7eb;\n  cursor: move;\n  transition: all 0.2s;\n  background: #f9fafb;\n}\n\n.ImengImageGenNode-image-thumb:hover {\n  border-color: #6366f1;\n  transform: scale(1.05);\n  z-index: 10;\n  box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);\n}\n\n.ImengImageGenNode-image-dragging {\n  opacity: 0.5;\n  transform: scale(0.95);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n\n.ImengImageGenNode-thumb-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.ImengImageGenNode-thumb-index {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background: rgba(99, 102, 241, 0.9);\n  color: white;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n/* 复制按钮样式 */\n.ImengImageGenNode-duplicate-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  color: #666;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.ImengImageGenNode-container:hover .ImengImageGenNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.ImengImageGenNode-duplicate-button:hover {\n  background: #f0f0f0;\n  border-color: #6366f1;\n  color: #6366f1;\n  transform: scale(1.05);\n}\n\n.ImengImageGenNode-duplicate-button:active {\n  transform: scale(0.95);\n}\n\n.react-flow__node.selected .ImengImageGenNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n/* 响应式设计 */\n@media (max-width: 480px) {\n  .ImengImageGenNode-container {\n    min-width: 280px;\n  }\n\n  .ImengImageGenNode-wrapper {\n    width: 280px;\n  }\n\n  .ImengImageGenNode-image-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n/* 动画效果 */\n@keyframes imengPulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n.ImengImageGenNode-generate:not(.ImengImageGenNode-generate-disabled) {\n  animation: imengPulse 2s infinite;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
